import { useState, useEffect } from "react";
import "./wellnessTrackerStyles.css";

function WellnessTracker({ wellnessItems }) {
    const [activeItem, setActiveItem] = useState(0);
    const [isMobile, setIsMobile] = useState(false);
    const [imageLoad, setImageLoad] = useState(false);

    const handleItemClick = (index) => {
        setActiveItem(index);
        setImageLoad(true);

        setTimeout(() => {
            setImageLoad(false);
        }, 500);
    };

    useEffect(() => {
        // Check if window is defined (client-side)
        if (typeof window !== "undefined") {
            setIsMobile(window.innerWidth < 768);

            // Add a resize event listener to update isMobile on window resize
            const handleResize = () => {
                setIsMobile(window.innerWidth < 768);
            };

            window.addEventListener("resize", handleResize);

            // Cleanup the event listener when component unmounts
            return () => {
                window.removeEventListener("resize", handleResize);
            };
        }
    }, []);

    return (
        <div className="container custom_container">
            <div
                className={`wt_container d-flex shadow-sm mt-3 mt-lg-5 text-light`}
            >
                <div
                    className={`wt_flex_1 pl-lg-5 py-3 py-lg-5 d-flex flex-column justify-content-center`}
                >
                    {wellnessItems.map((item, index) => (
                        <div
                            key={index}
                            className="p-3 text-center text-lg-left"
                        >
                            <div
                                onClick={() => handleItemClick(index)}
                                className={`
                                    wt_items
                                ${
                                    activeItem === index ? " wt_item_texts" : ""
                                }${activeItem !== index ? " active" : ""}`}
                            >
                                {item.title}
                                <span className="ml-2">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        fill="currentColor"
                                        className={`bi bi-chevron-right`}
                                        viewBox="0 0 16 16"
                                        style={{
                                            width:
                                                activeItem === index ? 25 : 18,
                                            fontWeight:
                                                activeItem === index
                                                    ? "bold"
                                                    : "normal",

                                            transform: !isMobile
                                                ? "rotate(0)"
                                                : `${
                                                      activeItem === index
                                                          ? "rotate(-90deg)"
                                                          : "rotate(90deg)"
                                                  }`,
                                        }}
                                    >
                                        <path
                                            fill-rule="evenodd"
                                            d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708"
                                        />
                                    </svg>
                                </span>
                                {/* {!isMobile && activeItem === index && (
                                    <hr className="wt_slide_bar" />
                                )} */}
                            </div>
                            {isMobile && activeItem === index && (
                                <div>
                                    <p
                                        className="section-para font-weight-normal mt-4 text-left fade_inn"
                                        dangerouslySetInnerHTML={
                                            item.description
                                        }
                                    />
                                    <div
                                        className={`${
                                            imageLoad ? `trans_top_to_bott` : ""
                                        }`}
                                    >
                                        <img
                                            src={
                                                wellnessItems[activeItem]
                                                    .imageSrc
                                            }
                                            alt={`Image ${activeItem + 1}`}
                                            className={`wt_img_mbl`}
                                        />
                                    </div>
                                </div>
                            )}
                            {!isMobile && activeItem === index && (
                                <p
                                    className="section-para font-weight-normal mt-4 fade_inn"
                                    dangerouslySetInnerHTML={item.description}
                                />
                            )}
                        </div>
                    ))}
                </div>

                <div
                    className={`wt_flex_2 ${isMobile ? "d-none" : "d-flex"}
                    `}
                >
                    {!isMobile && activeItem !== null && (
                        <div
                            className={`w-100 d-flex justify-content-end m-5 ${
                                imageLoad ? `fade_inn` : null
                            }`}
                        >
                            <img
                                src={wellnessItems[activeItem].imageSrc}
                                alt={`Image ${activeItem + 1}`}
                                className={`wt_img_sz  m-5 p-5`}
                            />
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}

export default WellnessTracker;
